import { render, staticRenderFns } from "./UserManage.vue?vue&type=template&id=4fc2ed65"
import script from "./UserManage.vue?vue&type=script&lang=js"
export * from "./UserManage.vue?vue&type=script&lang=js"
import style0 from "./UserManage.vue?vue&type=style&index=0&id=4fc2ed65&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports